// extracted by mini-css-extract-plugin
export default {"root":"oryaF","title":"aBlHW","phone":"wHZ4t"};